import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

class TypeService {
    public async getTypes(chantierId: number): Promise<any> {
        return http.get(Routes.TypeRoutes.GetTypes(chantierId));
    }
}

export default new TypeService();
